import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=2ecc7372&"
import script from "./LeftMenu.vue?vue&type=script&lang=js&"
export * from "./LeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&scope=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports